// extracted by mini-css-extract-plugin
export default {"header":"pPcws","tagline":"YoU4d","layout":"oS6uR","main":"hbf2Q","video":"JWPhW","curriculum":"TRZdr"};